/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { appState, setAlert } from "../../slices/appSlice";
import InputComp from "../generales/inputComponent";
import { changeStep as changeStepConv, registroConvocatoriaState } from "../../slices/registroConvocatoriaSlice";
import { ALERT_FAIL, CVE_DOCUMENTOS_CEMEFI, CVE_TIPODOC_CONVOCATORIA, DATOS_PARTICIPACION_STEP } from "../../app/constantes";
import { AvisosForm } from "../../app/forms/registro/avisos";
import { getDocumentosConv } from "../../services/entidad";
import DocumentComponent from "../generales/document";

export default function AvisosSection({ empresaSeleccionada }) {
    const dispatch = useDispatch();
    const registroSt = useSelector(registroConvocatoriaState);
    const appSt = useSelector(appState);
    const [documentos, setDocumentos] = useState([])
    const [canContinue, setCanContinue] = useState(false)
    const [form, setForm] = useState(JSON.parse(JSON.stringify(AvisosForm)));

    const nextStep = () => {
        dispatch(changeStepConv(DATOS_PARTICIPACION_STEP))
    }

    const getDocuments = async () => {
        try {
            const resp = await getDocumentosConv({
                ...appSt.serviceData,
                idConvocatoria: registroSt.convocatoriaSeleccionada.idConvocatoria,
                cveEtapa: "INSCRIPCION",
                cveTipoDocumento: CVE_TIPODOC_CONVOCATORIA
            })
            const filter = resp.filter((item) => item.cveDocumentoCemefi === CVE_DOCUMENTOS_CEMEFI.reglasOperacion || item.cveDocumentoCemefi === CVE_DOCUMENTOS_CEMEFI.aviso)
            setDocumentos(filter)
        } catch (error) {
            console.error(error)
            dispatch(setAlert({
                show: true,
                message: 'Error al consultar información',
                type: ALERT_FAIL
            }))
        }
    }


    useEffect(() => {
        let clone = JSON.parse(JSON.stringify(form))

        if (registroSt.convocatoriaSeleccionada) {
            clone.aceptoAviso.value = registroSt.convocatoriaSeleccionada.isAvisoAceptado === 1
            clone.aceptoCondiciones.value = registroSt.convocatoriaSeleccionada.isCondicionesAceptado === 1
            getDocuments()
        }
        setForm(clone)
    }, [registroSt.convocatoriaSeleccionada])

    useEffect(() => {
        setCanContinue((form.aceptoAviso.value === true || form.aceptoAviso.value === "true") && (form.aceptoCondiciones.value === true || form.aceptoCondiciones.value === "true"))
    }, [form.aceptoAviso.value, form.aceptoCondiciones.value])

    return (
        <div className="registro-documents">
            <div className="documents-wrapper">
                <div className="content">
                    <div className="documents">
                        {registroSt.convocatoriaSeleccionada && documentos && documentos.map((doc, index) => {
                            return (<DocumentComponent
                                disabled={true}
                                type={CVE_TIPODOC_CONVOCATORIA}
                                empresaSeleccionada={empresaSeleccionada}
                                doc={doc}
                                key={index}
                                convocatoriaSeleccionada={registroSt.convocatoriaSeleccionada} />)
                        })}
                    </div>
                    <div className="inputs-wrapper">
                        <InputComp
                            label="He leído y acepto las condiciones del aviso de privacidad de Cemefi"
                            name="aceptoAviso"
                            type="checkbox"
                            form={form}
                            setForm={setForm} />
                        <InputComp
                            label="He leído y acepto las reglas de operación de la convocatoria"
                            name="aceptoCondiciones"
                            type="checkbox"
                            form={form}
                            setForm={setForm} />
                    </div>
                </div>
            </div>


            <div className="actions">
                <button disabled={!canContinue} onClick={nextStep}>Continuar</button>
            </div>
        </div>
    )
}